<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
    <path
      d="M5.76839 4.91192C5.19166 4.33838 4.83464 3.54413 4.83464 2.6665C4.83464 1.78887 5.19166 0.99463 5.76839 0.42109C5.43635 0.258055 5.06285 0.166504 4.66797 0.166504C3.28726 0.166504 2.16797 1.28579 2.16797 2.6665C2.16797 4.04722 3.28726 5.1665 4.66797 5.1665C5.06285 5.1665 5.43635 5.07495 5.76839 4.91192Z"
      :fill="color" :fill-opacity="opacity" />
    <path
      d="M5.5013 2.6665C5.5013 1.28579 6.62059 0.166504 8.0013 0.166504C9.38201 0.166504 10.5013 1.28579 10.5013 2.6665C10.5013 4.04722 9.38201 5.1665 8.0013 5.1665C6.62059 5.1665 5.5013 4.04722 5.5013 2.6665Z"
      :fill="color" :fill-opacity="opacity" />
    <path
      d="M10.2342 0.42109C10.8109 0.99463 11.168 1.78887 11.168 2.6665C11.168 3.54413 10.8109 4.33838 10.2342 4.91192C10.5663 5.07495 10.9398 5.1665 11.3346 5.1665C12.7153 5.1665 13.8346 4.04722 13.8346 2.6665C13.8346 1.28579 12.7153 0.166504 11.3346 0.166504C10.9398 0.166504 10.5663 0.258055 10.2342 0.42109Z"
      :fill="color" :fill-opacity="opacity" />
    <path
      d="M3.5013 8.6665C3.5013 7.28579 4.62059 6.1665 6.0013 6.1665H10.0013C11.382 6.1665 12.5013 7.28579 12.5013 8.6665C12.5013 10.0472 11.382 11.1665 10.0013 11.1665H6.0013C4.62059 11.1665 3.5013 10.0472 3.5013 8.6665Z"
      :fill="color" :fill-opacity="opacity" />
    <path
      d="M0.167969 7.99984C0.167969 6.61913 1.28726 5.49984 2.66797 5.49984H6.0013C4.2524 5.49984 2.83464 6.9176 2.83464 8.6665C2.83464 9.34975 3.05102 9.98246 3.419 10.4998H2.66797C1.28726 10.4998 0.167969 9.38055 0.167969 7.99984Z"
      :fill="color" :fill-opacity="opacity" />
    <path
      d="M13.168 8.6665C13.168 9.34975 12.9516 9.98246 12.5836 10.4998H13.3346C14.7153 10.4998 15.8346 9.38055 15.8346 7.99984C15.8346 6.61913 14.7153 5.49984 13.3346 5.49984H10.0013C11.7502 5.49984 13.168 6.9176 13.168 8.6665Z"
      :fill="color" :fill-opacity="opacity" />
  </svg>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ color?: string; opacity?: string }>(), { color: '#3A3D44', opacity: '0.6' });
</script>
